module.exports = __webpack_public_path__ + "static/media/19ESCAP26.0baac157.jpg";